import { AloftDate, AloftPrice, AvgPricePerMonthTrend, isUndefined } from '@aloft/toolkit-shared';

import { toIsoMonth } from '../utils/toIsoMonth.js';
import { MonthGrouping } from '../zillow/types.js';

function getTypicalValueAtEffectiveDate(
  effectiveDate: AloftDate,
  trends: AvgPricePerMonthTrend[],
): AloftPrice | undefined {
  const effectiveDateMonthIndex = trends.findIndex((x) => x.month === effectiveDate.getMonth());
  if (effectiveDateMonthIndex === -1) return;
  return trends.at(effectiveDateMonthIndex)?.typicalHomeValue;
}

function getMonthGrouping(
  trend: AvgPricePerMonthTrend,
  typicalValueAtEffectiveDate: AloftPrice | undefined,
  compMonthMap?: Record<string, string[]>,
): MonthGrouping {
  const month = toIsoMonth(trend.year, trend.month);
  const percentChange = isUndefined(typicalValueAtEffectiveDate)
    ? 0
    : typicalValueAtEffectiveDate.sub(trend.typicalHomeValue).ratio(trend.typicalHomeValue) * 100;
  return {
    month,
    typicalValue: trend.typicalHomeValue,
    percentChange,
    // copied from getHousingTrendsData.ts
    ...(compMonthMap
      ? { affectedComps: compMonthMap[month]?.map((comp) => `C${comp}`).join(', ') }
      : {}),
  };
}

export function getHistoricalAvgPricePerMonthData(
  effectiveDate: AloftDate,
  trends: AvgPricePerMonthTrend[],
  compMonthMap?: Record<string, string[]>,
): MonthGrouping[] {
  const typicalValueAtEffectiveDate = getTypicalValueAtEffectiveDate(effectiveDate, trends);
  return trends.map((trend) => getMonthGrouping(trend, typicalValueAtEffectiveDate, compMonthMap));
}
